<template>
    <Layout>
      <PageHeader :title="title" :items="items" />
  
    <div class="row" v-if="userData.permissions['view_saving_packages']==1">
        <div class="col-12">
          <div class="card">
            <div class="card-body">
              <div class="mb-2 float-end">
                <b-button v-b-modal.new-option size="sm" variant="primary"><i class="mdi mdi-plus"></i> New Package</b-button>
              </div>
              <div class="clearfix"></div>
              <div class="row">
                <div class="col-sm-12 col-md-6">
                  <div id="tickets-table_length" class="dataTables_length">
                    <label class="d-inline-flex align-items-center">
                      Show <b-form-select class="form-select form-select-sm mx-1" v-model="perPage" size="sm" :options="Options"></b-form-select> entries
                    </label>
                  </div>
                </div>
                <div class="col-sm-12 col-md-6">
                  <div id="tickets-table_filter" class="dataTables_filter text-md-end" >
                    <label class="d-inline-flex align-items-center">
                      Search: <b-form-input v-model="filter" type="search" placeholder="Search..." class="form-control form-control-sm ms-2"></b-form-input>
                    </label>
                  </div>
                </div>
              </div>
              <div class="table-responsive">
                <b-table
                  :items="Items"
                  :fields="Fields"
                  responsive="sm"
                  :per-page="perPage"
                  :current-page="currentPage"
                  :filter="filter"
                  :filter-included-fields="filterOn"
                  @filtered="Filtered"
                  :busy="IsBusy"
                >
                <template #table-busy><div class="text-center text-primary my-2"><b-spinner class="align-middle" type="grow" small></b-spinner> <strong>No Data Found</strong></div></template>
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                <template #cell(amount)="data">
                  {{ commas(data.item.amount) }}
                </template>
                  <template #cell(active)="data">
                  <span v-if="data.item.active==1">
                    <b-button type="button" class="btn-sm btn" variant="info" v-b-modal.password> <i class="mdi mdi-check"></i> Active </b-button>
                  </span>
                  <span v-else>
                    <b-button @click="makedefault(data.item.id,data.item.name)" type="button" class="btn-sm btn" variant="secondary" v-b-modal.password> <i class="mdi mdi-lock"></i> Set as Active</b-button>
                    </span>
                  </template>
                <template #cell(actions)="data">
                  <div class="btn-group">
                  <b-button @click="edit(data.item.id,data.item.name,data.item.amount )" type="button" class="btn-sm btn" variant="primary" v-b-modal.edit> <i class="mdi mdi-square-edit-outline"></i> </b-button>
                  <b-button @click="remove(data.item.id,data.item.name)" type="button" class="btn-sm btn" variant="danger"  v-b-modal.delete> <i class="mdi mdi-trash-can"></i> </b-button>
                  </div>
                </template>
                </b-table>
              </div>
              <div class="row">
                <div class="col">
                  <div class="dataTables_paginate paging_simple_numbers float-end">
                    <ul class="pagination pagination-rounded mb-0">
                      <b-pagination v-model="currentPage" :total-rows="List" :per-page="perPage"></b-pagination>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-else>
      <div class="row justify-content-center">
        <div class="col-md-8 col-xl-6">
          <div>
            <img src="@/assets/images/profile-img.png" alt class="img-fluid" /><br><br>
            <center><span class="text-primary h6">You have no permission to view Saving Packages</span></center>
          </div>
        </div>
      </div>
    </div>
      <b-modal id="new-option" centered title="New Saving Package" title-class="font-18" hide-footer>
          <form @submit.prevent="addPackage">
              <div class="form-group mb-2">
              <label>Name</label>
              <input v-model="name" type="text" class="form-control" />
              </div>
              <div class="form-group mb-2">
              <label>Amount</label>
              <input v-model="amount" type="number" class="form-control" />
              </div>
              <div class="form-group d-flex justify-content-end">
                  <b-button type="button" class="btn w-30" variant="secondary" @click="$bvModal.hide('new-option')" >Cancel</b-button>
                  <b-button type="submit" class="btn ms-1 w-30" variant="primary" ><i class="fas fa-check-circle"></i> Submit</b-button>
              </div>
          </form>
      </b-modal>
  
      <b-modal id="edit-option" centered title="Edit Saving Package" title-class="font-14" hide-footer>
          <form @submit.prevent="editPackage">
              <div class="form-group mb-2">
              <input v-model="id" type="hidden">
              <label>Name</label>
              <input v-model="name" type="text" class="form-control" />
              </div>
              <div class="form-group mb-2">
              <label>Amount</label>
              <input v-model="amount" type="number" class="form-control" />
              </div>
              <div class="form-group d-flex justify-content-end">
                  <b-button type="button" class="btn w-30" variant="secondary" @click="$bvModal.hide('edit-option')" >Cancel</b-button>
                  <b-button type="submit" class="btn ms-1 w-30" variant="primary" ><i class="fas fa-check-circle"></i> Submit</b-button>
              </div>
          </form>
      </b-modal>
    
      <b-modal id="delete-option" centered title="Delete Saving Package" title-class="font-12" hide-footer>
          <form @submit.prevent="removePackage">
              <input v-model="id" type="hidden">
                Are you sure you want to delete the Saving Package : <b>{{ name }}</b> ?
              <div class="form-group d-flex justify-content-end">
                  <b-button type="button" class="btn w-30" variant="secondary" @click="$bvModal.hide('delete-option')" >Cancel</b-button>
                  <b-button type="submit" class="btn ms-1 w-30" variant="primary" ><i class="fas fa-check-circle"></i> YES</b-button>
              </div>
          </form>
      </b-modal>
  
    </Layout>
  </template>
  
  <script>
  import axios from "axios";
  // import Multiselect from "vue-multiselect";
  import Layout from "../../layouts/main";
  import PageHeader from "@/components/page-header";
  import appConfig from "@/app.config";
  import { savingpackageMethods, savingpackageComputed } from "@/state/helpers";
  
  export default {
    page: {
      title: "Saving Packages",
      meta: [{ name: "description", content: appConfig.description,},],
    },
    components: {
      Layout,PageHeader
    },
    data() {
      return {
        userData: JSON.parse(localStorage.getItem("user")),
        title: "Saving Packages",
        items: [ {text: "Dashboard",to: "/",}, {text: "Saving Packages",active: true, }, ],
        TotalRows: 1,
        currentPage: 1,
        perPage: 10,
        Options: [10, 50, 100, 150, 200],
        filter: null,
        todoFilter: null,
        filterOn: [],
        sortDesc: true,
        isBusy: true,
        fields: [
            { key: 'index', label: '#', visible: true },
            { key: 'id', label: 'ID', visible: false },
            { key: 'name', label: 'Name', visible: true },
            { key: 'amount', label: 'Amount', visible: true },
            { key: 'actions', label: 'Actions', visible: true },
          ],
        id:'', name:'', amount:'',
      };
    },
    computed: {
      ...savingpackageComputed,
      List() { return this.savingpackages.length; },
      Fields() { return this.fields.filter(field => field.visible) },
      Items() { return this.savingpackages.map((d) => ({...d }))},
      IsBusy() { let a=false; if (this.savingpackages.length>0) { a=false;} else { a=true;} return a },
    },
    mounted() {
      this.fetchSavingPackages();
      this.TotalRows = this.savingpackages.length;
      this.isBusy=false;
    },
    methods: {
      ...savingpackageMethods,
      commas(x) { return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','); },
      Filtered(filteredItems) {
        this.TotalRows = filteredItems.length;
        this.currentPage = 1;
      },
      edit(id,name,amount){
        this.id=id;
        this.amount=amount;
        this.name=name;
        this.$bvModal.show('edit-option')
      },
      remove(id,name){
        this.id=id;
        this.name=name;
        this.$bvModal.show('delete-option')
      },
      async addPackage() { 
        let formData = new FormData();
        formData.append("name", this.name);
        formData.append("amount", this.amount);
        let url = "/addsavingpackage";
        await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
            this.fetchSavingPackages();
            this.$bvModal.hide('new-option');
            this.name="";
            this.amount="";
        }
        });
      },
      async editPackage(){ 
      let formData = new FormData();
      formData.append("id", this.id);
      formData.append("name", this.name);
      formData.append("amount", this.amount);
      let url = "/updatesavingpackage";
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          this.fetchSavingPackages();
          this.$bvModal.hide('edit-option');
          this.name="";
          this.amount="";
        }
      });
      },
      async removePackage() { 
      let formData = new FormData();
      formData.append("id", this.id);
      let url = "/removesavingpackage";
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          this.fetchSavingPackages();
          this.$bvModal.hide('delete-option');
        }
      });
      },
    },
  };
  </script>